import React, {useRef, useState} from 'react';
import styles from "./admin-required-documents.module.scss";
import {Col, Row, Table, Button, Spinner, ProgressBar} from "react-bootstrap";
import acceptIcon from "../../../../../../assets/orders-table-accept.svg";
import pendingIcon from "../../../../../../assets/orders-table-pending.svg";
import ListingService from "../../../../../../services/listing-service";
import rejectIcon from "../../../../../../assets/orders-table-reject.svg";
import ModalCustom from "../../../../../../components/modal/modal";
import {useValidation} from "../../../../../../hooks/use-validation";
import {TextInput} from "../../../../../../components/form/form";
import {required} from "../../../../../../helpr/generic-validation-rules";

const AdminRequiredDocuments = ({context}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  //Modal State
  const { applicationId, requiredDocuments, setRequiredDocuments} = context;
  const listingService = new ListingService();
  const selectedDocument = useRef({});

  const tableHeaders = [
    {value: 'Document Name', class: ''},
    {value: 'Status', class: ''}
  ]

  const renderStatus = (doc) => {
    switch(doc.documentStatus){
      case '1':
        return <span><img alt="Submitted" src={acceptIcon}/>  Submitted</span>
      case '0':
        return <span><img alt="Pending" src={pendingIcon}/>  Pending</span>
      case '2':
        return <span><img alt="Approved" src={acceptIcon}/>  Approved</span>
      case '3':
        return <span><img alt="Rejected" src={rejectIcon}/>  {`Rejected (${doc.reason})`}</span>
      default:
    }
  }

  const renderAction = document => {
    const status = document.documentStatus;
    switch(status) {
      case '1':
        return <div className={styles['button-action']}>
          <Button variant="secondary" onClick={() => viewDocument(document)}>VIEW</Button>
          {/* <Button variant="primary" disabled={loading} onClick={() => approveDocument(document)}>
            { loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>: 'APPROVE' }
          </Button> */}
          <Button variant="danger" disabled={loading} onClick={() => showDocumentRejectionModal(document)}>
            { loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>: 'REJECT' }
          </Button>
        </div>
      case '2':
        return <div className={styles['button-action']}>
          <Button variant="secondary" onClick={() => viewDocument(document)}>VIEW</Button>
          <Button variant="danger" disabled={loading} onClick={() => showDocumentRejectionModal(document)}>
            { loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>: 'REJECT' }
          </Button>
        </div>
      case '3':
        return <div className={styles['button-action']}>
          <Button variant="secondary" onClick={() => viewDocument(document)}>VIEW</Button>
        </div>
      default:
        return '';
    }
  }

  const viewDocument = async document => {
    try {
      const result = await listingService.retrieveRequiredDocument(applicationId, document.sortKey, document.key);
      const newWindow = window.open(result['url'], '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    } catch(error) {}
  }

  const rejectDocument = async document => {
    try {
      setLoading(true)
      await listingService.rejectRequiredDocument(applicationId, document.sortKey, document.key, "HEHEHE");
      setRequiredDocuments(prev => {
        const updatedList = prev.map(d => {
          if(d.sortKey === document.sortKey){
            return {
              ...d,
              documentStatus: '3'
            }
          }
          return d
        });
        return updatedList
      });
    } catch(error) {}
    finally {
      setLoading(false)
    }
  }

  const approveDocument = async document => {
    try {
      setLoading(true)
      await listingService.approveRequiredDocument(applicationId, document.sortKey, document.key);
      setRequiredDocuments(prev => {
        const updatedList = prev.map(d => {
          if(d.sortKey === document.sortKey){
            return {
              ...d,
              documentStatus: '2'
            }
          }
          return d
        });
        return updatedList
      });
    } catch(error) {}
    finally {
      setLoading(false)
    }
  }

  const computePercentage = () => {
    console.log(requiredDocuments.filter(d => d.documentStatus == '1').length);
    return Math.trunc((requiredDocuments.filter(d => d.documentStatus == '2').length / requiredDocuments.length) * 100);
  }

  const showDocumentRejectionModal = (doc) => {
    selectedDocument.current = doc
    setShowModal(true)
  }

  return (
    <div className={`${styles['admin-required-documents']} ${styles['panel']}`} >
      <Row>
        <Col>
          <div className={styles['table-heading']}>
            Documentary Requirements for Listing / Enrollment - Checklist and Completion Status
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={styles['term-sheet-status']}>
            Status:
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={4}>
          <div>
            <ProgressBar className={styles['progress']} now={computePercentage()} label={`${computePercentage()}%`} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Table responsive>
            <thead>
            <tr>
              {tableHeaders.map(
                (header, index) => {
                  return <th className={styles[header['class']]} key={index}>{header.value}</th>
                }
              )}
            </tr>
            </thead>
            <tbody>
            {
              requiredDocuments.map((d, index) => {
                return (
                  <tr key={index}>
                    <td className={styles['document-name']}>{d.documentName}</td>
                    <td>{renderStatus(d)}</td>
                    <td>{renderAction(d)}</td>
                  </tr>
                )
              })
            }
            </tbody>
          </Table>
          {
            requiredDocuments.length > 0 ? ''
              : <div className={styles['no-data']}>No required documents to display.</div>
          }
        </Col>
      </Row>
      <ModalCustom
          show={showModal}
          title="Document Submission Rejection"
          onClose={() => setShowModal(false)}
          component={<RejectDocumentModalContent applicationId={applicationId} selectedDocument={selectedDocument} setRequiredDocuments={setRequiredDocuments} onClose={() => setShowModal(false)} />}
          style={styles['doc-rejection-modal']} />
    </div>
  )
}

const RejectDocumentModalContent = ({applicationId, selectedDocument, setRequiredDocuments, onClose}) => {

  //Service call states
  const [ loading, setLoading] = useState(false);
  const listingService = new ListingService();

  //Validator
  const rejectInfoState = useValidation(
      rejectInfoValidator,
      rejectInfoObj({
        rejectReason: ''
      }),
      {border: '1px solid red'});
  const { validate, getTextFieldProps } = rejectInfoState;

  const rejectDocument = async () => {
    const { formState, isFormValid } = validate();
    console.log(formState);
    if(!isFormValid){
      return
    }
    setLoading(true);
    try {
      console.log(selectedDocument)
      await listingService.rejectRequiredDocument(applicationId, selectedDocument.current.sortKey, selectedDocument.current.key, formState.rejectReason);
      setRequiredDocuments(prev => {
        const updatedList = prev.map(d => {
          if(d.sortKey === selectedDocument.current.sortKey){
            return {
              ...d,
              documentStatus: '3',
              reason: formState.rejectReason
            }
          }
          return d
        });
        return updatedList
      });
    } catch(error) {}
    finally {
      setLoading(false)
      onClose()
    }
  }

  return (
      <div className={styles['reject-document-modal-content']}>
        <Row>
          <Col lg={{offset: 1, span: 10}}>
            <Row>
              <Col lg={12}>
                <TextInput inputProps={getTextFieldProps('rejectReason')} placeholder={""} >
                  Reason for Rejection
                </TextInput>
              </Col>
            </Row>
            <Row className={styles['button-row']}>
              <Col xs={6} lg={6}>
                <div className={styles['back-button']}>
                  <Button variant="secondary" onClick={() => onClose()}>
                    BACK
                  </Button>
                </div>
              </Col>
              <Col xs={6} lg={6}>
                <div className={styles['reject-button']}>
                  <Button disabled={loading} onClick={() => rejectDocument()}>
                    {loading ? <Spinner size="sm" animation="border"/> : 'REJECT'}
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
  )
}

const rejectInfoObj = obj => {
  return {
    fields: {
      rejectReason: {
        value: obj.rejectReason,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

const rejectInfoValidator = {
  fields: {
    rejectReason: [required]
  },
  dynamicFields: {}
}

export default AdminRequiredDocuments;
